import { forIn } from "lodash";

//数据字典关联
const sysDictMange = {
    storekey:'sys_dict_data_key',
	save(data){
        if(data){
            try {
                let value = JSON.stringify(data);
                sessionStorage.setItem(sysDictMange.storekey, value);
            } catch (error) {
                console.log(error);
            }
        }
    },
    getDictByKeys(keys=[]){
        let result = null;
        try {
            if(!keys || keys.length<=0){
                return result;
            }
            let dataStr = sessionStorage.getItem(sysDictMange.storekey);
            if(dataStr){
                let data = JSON.parse(dataStr);
                result = {};
                keys.forEach(key => {
                    let dictList = data[key] || [];
                    result[key] = dictList;
                });
                if(keys.length==1){
                    result = result[keys[0]];
                }
            }
        } catch (error) {
            console.log(error);
        }
        return result;
    },
    getDictMap(key){
        let result = {};
        let dictList = sysDictMange.getDictByKeys([key]);
        if(dictList){
            dictList.forEach(row => {
                result[row.key] = row.name;
            });
        }
        return result; 
    },
    //根据数据字典key 获取字典值
    getDictValueByKey(dictKey,key){
        let dictMap = sysDictMange.getDictMap(dictKey) || {};
        let result = dictMap[key] || "";
        return result; 
    },
    //根据数据字典值 获取字典key
    getDictKeyByValue(dictKey,value){
        let result = "";
        let dictMap = sysDictMange.getDictMap(dictKey) || {};
        for (const key in dictMap) {
            if (Object.hasOwnProperty.call(dictMap, key)) {
                const dbValue = dictMap[key];
                if(dbValue==value){
                    result = key;
                    break;
                }
            }
        }
        return result; 
    }
    
}

export default sysDictMange;
